import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import requests from 'app/requests/Gateway.requests'
import {
    Gateway,
} from '../Gateways.types'

export default function useGetGateway(id:number) {
    return useRequest<Gateway>({
        key: RequestKeys.getGateway,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(requests.get),
        enabled: Boolean(id),
    })
}
